import React from "react";
import styles from "./houseManagerProfile.module.css";
import { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useLocation, Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faStar, faUserCircle, faPaperPlane, faMessage  } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faTwitter, faTiktok, faInstagram, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import Messagingmodal from "./Messaging";
import useProfileData from './housemanager/hooks/useProfileData';
import AlbumsSection from './housemanager/AlbumsSection';
import ContactForm from './housemanager/ContactForm';
import ContractSection from './housemanager/ContractSection';
import MessagingModal from './housemanager/MessagingModal';
import ProfileHeader from './housemanager/ProfileHeader';
import ReviewsSection from './housemanager/ReviewsSection';


const baseURL = `${process.env.REACT_APP_API_URL}`

const HouseManagerProfile = () => {
    const { profile, loading, error } = useProfileData();
    const [showContactForm, setShowContactForm] = useState(false);
    const [message, setMessage] = useState('');
    const [success, setSuccess] = useState('');
    const { id } = useParams();
    const [reviews, setReviews] = useState([]);
    const [newReviews, setNewReviews] = useState('');
    const [newRating, setNewRating] = useState()
    const location = useLocation()
    const [contract, setContract] = useState(null)
    const [customUserId, setCustomUserId] = useState(null)
    const [isImageModalOpen, setIsImageModalOpen] = useState(false)


    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 2;

    const [isMessagingOpen, setIsMessagingOpen] = useState(false)
    
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [newContract, setNewContract] = useState({
      terms: '',
      start_date: '',
      end_date: '',
      status: '',
      payment_amount: '',
      payment_status: '',
      is_renewable: false,
      days_per_month: '',
      termination_date: '',
      termination_reason: '',
      contract_document: '',
    });
    

    // const userType = location.pathname.includes("house_manager") ? "house_manager" : "employer";
    const LoginUserId = localStorage.getItem('userId')

    console.log('Current house manager data:', profile)

    

    // useEffect(() => {
    //   if (!profile) return;

    //   const fetchUserID = async () => {
    //     try {
    //       axios.get(`${baseURL}/profiles/custom_user_id/${id}/`)
    //     .then((response) => {
    //       setCustomUserId(response.data.custom_user_id);
    //       console.log('Fetched Custom User ID:', response.data.custom_user_id);
    //     })
    //     .catch((error) => {
    //         console.error('Error fetching Custom User ID:', error);
    //     });
    //     } catch (error) {
    //       console.error('Error in fetchUserID:', error);
    //     }
    //   }
        
    //   fetchUserID();

    // }, [id, profile]);

    // useEffect(() => {
    //   if (profile) {
    //     const userId = profile.user_id;

    //     const fetchReviews = async () => {
    //       try {
    //         const response = await axios.get(`${baseURL}/profiles/reviews/${userId}/`);
    //         setReviews(response.data)
    //         console.log(`Reviews API URL: ${baseURL}/profiles/reviews/${userId}/`)
    //         console.log(`Fetched reviews for user ID ${userId}:`, response.data)
    //       } catch (error) {
    //         console.error('Error fetching reviews:', error);
    //       }
    //   };

    //     fetchReviews();
    //   }

      
    // }, [ profile]);

    // useEffect(() => {
    //     const fetchContract = async () => {
    //         if (!id) return; 
    //         try {
    //             const response = await axios.get(`${baseURL}/profiles/contracts/${id}/`)
    //             setContract(response.data)
    //             console.log('fetching contract for house manager with ID:', id)
    //             console.log('contract fetched:', response.data)
    //         } catch(error) {
    //             console.error('Error fetching contract:', error);
    //         }
    //     }

    //     fetchContract()
    // }, [id])




    // const handleCreateContract = async (id, e) => {
    //   e.preventDefault();
    //   setSuccess('')

    //   const {start_date, end_date} = newContract;

    //   if (new Date(end_date) <= new Date(start_date)) {
    //     console.error('End date should be after start date')
    //     return;
    //   }

    //   if (newContract.contract_document && newContract.contract_document.size > 5 * 1024 * 1024) {
    //     console.error('Contract document size should be less than 5MB')
    //     return;
    //   }

    //   const token = localStorage.getItem('accessToken')
    //   if (!token) {
    //     console.error('AccessToken not found in localStorage');
    //     console.error('Please log in to create a contract')
    //     return;
    //   }

    //   const formData = new FormData();
    //   formData.append('house_manager', id);
    //   formData.append('employer', LoginUserId);
    //   formData.append('contract_document', newContract.contract_document);

    //   Object.keys(newContract).forEach((key) => {
    //     if (key !== 'contract_document[key]') {
    //       formData.append(key, newContract[key]);
    //     }
    //   });


    //   try {
    //     const response = await axios.post(
    //       `${baseURL}/profiles/create_contract/`, 
    //       formData,
    //       {
    //         headers: {
    //         Authorization: `Bearer ${token}`},
    //       },
    //     );
    //     setNewContract(response.data.contract)
    //     setSuccess(response.data.message)
    //     console.log('Contract created successfully:', response.data.contract)
    //     setIsModalOpen(false)
    //   } catch (error) {
    //     if (error.response) {
    //       console.error(error.response.data.error || 'An error occured')
    //       console.log('Error Response:', error.response.data)
    //     } else {
    //       console.error('An error occured while creating the contract')
    //     }
    //   }
    // };

    // const handleContractInputchange = (e) => {
    //   setNewContract({...newContract, [e.target.name]: e.target.value});
    // };

      // const handleSendMessage = () => {
      //   if (!message.trim()) {
      //     console.error('Message cannot be empty')
      //     return;
      //   }
      //   const token = localStorage.getItem('accessToken');
      //   if (!token) {
      //     console.error('AccessToken not found in localStorage');
      //   }
      //   console.log('AccessToken:', token)
      //   axios
      //     .post(
      //       `${baseURL}/profiles/contact-house-manager/`,
      //       {
      //         houseManagerId: id,
      //         message,
      //       },
      //       {
      //         headers: {
      //           Authorization: `Bearer ${token}`,
      //         },
      //       }
      //     )
      //     .then(() => {
      //       setSuccess("Message sent successfully");
      //       setMessage("");
      //       setShowContactForm(false);
      //     })
      //     .catch((error) => {
      //       console.error('Error sending message:', error)
      //       if (error.response && error.response.status === 401) {
      //         console.error("Unauthorized: Please log in again")
      //       } else {
      //         console.error("Error has occurred while sending your message");
      //       }
      //     });

      // };


      // const handleReviewsSubmit = () => {
      //   if (!newReviews.trim()) {
      //     console.error('Review cannot be empty')
      //     return;
      //   }

      //   const token = localStorage.getItem('accessToken')
      //   if (!token) {
      //     console.error('Please log in to submit a review')
      //     return;
      //   }

      //   if (newRating < 1 || newRating > 5) {
      //     console.error('Rating must be between 1 and 5')
      //     return;
      //   }

      //   if (!userType || !id) {
      //     console.error('User type or ID not found')
      //     return;
      //   }
      //   axios
      //     .post(
      //       `${baseURL}/profiles/reviews_submit/${userType}/${id}/`,
      //         {
      //           comment: newReviews,
      //           rating: newRating,
      //         },
      //         {
      //           headers: {
      //             Authorization: `Bearer ${token}`
      //           },
      //         }
      //     )
      //     .then((response) => {
      //       console.log('Submitted reviews:', response.data)
      //       setSuccess('Review submitted successfully')
      //       setReviews([...reviews, response.data])
      //       setNewReviews('')
      //       setNewRating(0)
      //     })
      //     .catch((error) => {
      //         if (error.response && error.response.data) {
      //           console.error(error.response.data.non_field_errors || "An error occurred")
      //         } else {
      //           console.error("An error occurred")
      //         }
      //     });
      // };

      // const openMessagingModal = () => {
      //   setIsMessagingOpen(true);
      // };

      // const closeMessagingmodal = () => {
      //   setIsMessagingOpen(false);
      // }

      
      const handleOpenModal = () => setIsModalOpen(true)
      const handleCloseModal = () => setIsModalOpen(false)

      // const handleImageClick = () => setIsImageModalOpen(true)
      // const handleCloseImageModal = () => setIsImageModalOpen(false)

      // const indexOfLastReview = currentPage * itemsPerPage;
      // const indexOfFirstReview = indexOfLastReview - itemsPerPage;
      // const currentReview = reviews.slice(indexOfFirstReview, indexOfLastReview);
    
      if (loading) 
        return (
          <div className={styles.loadingContent}>
            <FontAwesomeIcon icon={faSpinner} spin size="3x" className={styles.spinner} />
            <span className={styles.loadingText}>Loading...</span>
          </div>
        );
      if (!profile) return <p>Profile not found</p>;
      if (profile?.image) {
          const imageUrl = `${baseURL}/profiles${profile.image}`;
          console.log(`Full image URL for house manager ${profile.id}: ${imageUrl}`);
      }


  return (
    <div className={styles.profileContainer}>
      {success && (
      <div className={styles.successMessageDiv}>
          {error && <p className={styles.error}>{error}</p>}
          {success && <p className={styles.success}>{success}</p>}
      </div>
      )}

      {/* <Messagingmodal 
        isOpen={isMessagingOpen}
        onClose={closeMessagingmodal}
        recipientId={profile.user_id}
        recipientName={`${profile.first_name} ${profile.last_name}`}
      /> */}

      {/* {isImageModalOpen && (
        <div className={styles.imageModal}>
          <div className={styles.imageModalContent}>
            <button
              className={styles.closeButton}
              onClick={handleCloseImageModal}
            >
              &times;
            </button>
            <img 
              src={`${baseURL}${profile.image}`}
              alt={`${profile.first_name} ${profile.last_name}`}
              className={styles.fullSizeImage}
            />
          </div>
        </div>
      )} */}

      {/* {isModalOpen && (
        <div className={styles.modal}>
          <div className={styles.modalContent}>
            <h3>Contract for {profile.first_name} {profile.last_name}</h3>
            <form onSubmit={(e) => handleCreateContract(id, e)}>
              <label>
                Terms:
                <textarea 
                  name="terms"
                  value={newContract.terms}
                  onChange={handleContractInputchange}
                />
              </label>
              <br />
              <label>
                Start Date:
                <input 
                  type="date"
                  name="start_date"
                  value={newContract.start_date}
                  onChange={handleContractInputchange}
                />
              </label>
              <br />
              <label>
                End Date:
                <input 
                  type="date"
                  name="end_date"
                  value={newContract.end_date}
                  onChange={handleContractInputchange}
                />
              </label>
              <br />
              <label>
                Payment Day: 
                <select 
                  name="payment_day"
                  value={newContract.payment_day}
                  onChange={handleContractInputchange}
                >
                  <option value="Daily">Daily</option>
                  <option value="Monthly">Monthly</option>
                  <option value="Yearly">Yearly</option>
                </select>
              </label>
              <br />
              <label>
                Payment Amount:
                <input 
                  type="number"
                  name="payment_amount"
                  value={newContract.payment_amount}
                  onChange={handleContractInputchange}
                />
              </label>
              <br />
              <label>
                Renewable: 
                <input 
                  type="checkbox"
                  name="is_renewable"
                  checked={newContract.is_renewable}
                  onChange={(e) => setNewContract({
                    ...newContract, is_renewable:e.target.checked
                  })}
                />
              </label>
              <br />
              <label>
                Days To Work Per Month:
                <input 
                  type="number"
                  name="days_per_month"
                  value={newContract.days_per_month}
                  onChange={handleContractInputchange}
                />
              </label>
              <br />
              <label>
                Termination Date:
                <input 
                  type="date"
                  name="termination_date"
                  value={newContract.termination_date}
                  onChange={handleContractInputchange}
                />
              </label>
              <br />
              <label>
                Termination Reason:
                <textarea 
                  name="termination_reason"
                  value={newContract.termination_reason}
                  onChange={handleContractInputchange}
                />
              </label>
              <br />
              <label>
                Contract Document:
                <input 
                  type="file"
                  name="contract_document"
                  onChange={(e)=> setNewContract({
                    ...newContract, contract_document: e.target.files[0]
                  })}
                />
              </label>

              <button type="submit">Create Contract</button>
              <button type="button" onClick={handleCloseModal}>Cancel</button>
            </form>
          </div>
        </div>
      )} */}
      <ProfileHeader />
      {/* <div className={styles.header}>
        <div className={styles.leftSection}>
          <div className={styles.subHeader}>
            <img
              src={`${baseURL}${profile.image}`}
              alt={`${profile.first_name} ${profile.last_name}`}
              className={styles.profileImage}
              onClick={handleImageClick}
            />
            <div className={styles.basicInfo}>
              <h1 className={styles.name}>
                {profile.first_name} {profile.last_name}
              </h1>
              <p className={styles.location}>
                <FontAwesomeIcon icon={faMapMarkerAlt} style={{color: '#007bff'}}/> {profile.location}
              </p>
              <p className={styles.rating}>
                <FontAwesomeIcon icon={faStar} style={{color: '#f39c12'}}/> {profile.rating.toFixed(1)}/5
              </p>
              <button
                className={styles.contactButton}
                onClick={() => setShowContactForm(true)}
                >
                Contact Me
              </button>
              <span className={styles.messageButton} onClick={openMessagingModal}>
              <FontAwesomeIcon icon={ faMessage } style={{color: '#f39c12', fontSize: '30px'}}/>
              <FontAwesomeIcon icon="fa-solid fa-message" />
              </span>
            </div>
            
          </div>
          <div className={styles.shareSection}>
              <h3>Share {profile.first_name} Profile</h3>
              <div className={styles.shareIcons}>
                <div>
                  <a
                    href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(
                      `http://localhost:3000/profile/house_manager/${profile.id}`
                    )}&text=Check out ${profile.first_name}'s profile!`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon icon={faTwitter} className={styles.shareIcon} />
                  </a>
                </div>
                <div>
                  <a
                    href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                      `http://localhost:3000/profile/house_manager/${profile.id}`
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon icon={faFacebook} className={styles.shareIcon} />
                  </a>
                </div>
                <div>
                  <a
                    href={`https://www.tiktok.com/share?url=${encodeURIComponent(
                      `http://localhost:3000/profile/house_manager/${profile.id}`
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon icon={faTiktok} className={styles.shareIcon} />
                  </a>
                </div>
                <div>
                  <a
                    href={`https://www.instagram.com/?url=${encodeURIComponent(
                      `http://localhost:3000/profile/house_manager/${profile.id}`
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon icon={faInstagram} className={styles.shareIcon} />
                  </a>
                </div>
                <div>
                  <a
                    href={`https://api.whatsapp.com/send?text=${encodeURIComponent(
                      `Check out ${profile.first_name}'s profile: http://localhost:3000/profile/house_manager/${profile.id}`
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon icon={faWhatsapp} className={styles.shareIcon} />
                  </a>
                </div>
              </div>
          </div>
          <div className={styles.reviewForm}>
              <div>
                <h3>Leave {profile.first_name} a Review </h3>
              </div>
              <div className={styles.reviewFormInputs}>
                <textarea
                  value={newReviews}
                  onChange={(e)=> setNewReviews(e.target.value)}
                  placeholder="Write your review"
                  className={styles.reviewInput}
                />
                <input
                  type="number"
                  min='1'
                  max='5'
                  value={newRating}
                  onChange={(e) => setNewRating(Number(e.target.value))}
                  className={styles.reviewInput}
                  placeholder="min 1 and max 5"
                />
                <button 
                  className={styles.submitButton} 
                  onClick={handleReviewsSubmit}>
                    Submit Review
                </button>
              </div>
          </div>
            <div className={styles.contractStatus}>
              {contract && contract.length > 0 ? (
                <div>
                  <h3>Contract Status</h3>
                  {contract.map((c) => (
                    <div key={c.id} className={styles.contract}>
                        {c.status === 'Pending' || c.status === 'Declined' ? (
                          <p>{profile.first_name} has {c.status} Contract for {c.employer_name} </p>
                        ) : (
                          <div>
                            <p>{profile.first_name} has a contract with {c.employer_name} that expires on {c.end_date}</p>
                            <p>Status: <strong>Active</strong></p>
                          </div>
                        )}
                    </div>
                  ))}
                </div>
              ) : (
                <div>
                  <p>No contract available</p>
                  {userType !== 'employer' && (
                    <button onClick={handleOpenModal} className={styles.createContractbutton}>
                        Create Contract
                      </button>
                  )}
                </div>
              )}
            </div>
        </div>
            { showContactForm && (
              <div className={styles.contactForm}>
                <h2>Contact {profile.first_name}</h2>
                <textarea
                  className={styles.messageInput}
                  placeholder="Write your message"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                />
                <div className={styles.formButton}>
                  <button className={styles.sendButton} onClick={handleSendMessage}>
                    Send Message
                  </button>
                  <button className={styles.cancelButton} onClick={() => setShowContactForm(false)}>
                    Cancel
                  </button>
                </div>
              </div>
            ) }
        <div className={styles.reviewSection}>
            <h2>Reviews</h2>
            <div className={styles.subSection}>
            {reviews.length > 0 ? (
              <>
                {currentReview.map((review) => (
                  <div key={review.id} className={styles.review}>
                    <p><FontAwesomeIcon icon={faStar} style={{color: 'orange'}}/> ({review.rating.toFixed(1)}/5)</p>
                    <p>{review.comment}</p>
                    <small>{new Date(review.created_at).toLocaleDateString()}</small> by <Link
                            to={`/profile/employer/${review.reviewer_id}`}
                            key={review.id}
                            className={styles.resultCard}
                        >
                          <strong>{review.reviewer_username}</strong>
                        </Link>
                  </div>
                ))}
              </>
              
            ) : (
              <p>No Reviews Yet!</p>
            )}
            </div>
            <div className={styles.pagination}>
                <button 
                  className={styles.pageButton}
                  onClick={() => setCurrentPage((prev) => Math.max(prev-1, 1))}
                  disabled={currentPage === 1}
                  >
                    ◀ Previous
                </button>
                  <span className={styles.pageNumber}> Page {currentPage} </span>
                <button 
                  className={styles.pageButton}
                  onClick={() => setCurrentPage((prev) =>(prev * itemsPerPage < reviews.length ? prev + 1 : prev))}
                  disabled={indexOfLastReview >= reviews.length}
                  >
                  Next ▶
                </button>
            </div>
        </div>
        
      </div> */}

      <div className={styles.detailsSection}>
        <div className={styles.bio}>
          <h2>About</h2>
          <p>{profile.bio || "No bio available."}</p>
        </div>

        <div className={styles.detailsGrid}>
          <div>
            <h3>Age</h3>
            <p>{profile.age}</p>
          </div>
          <div>
            <h3>Gender</h3>
            <p>{profile.gender}</p>
          </div>
          <div>
            <h3>Hobbies</h3>
            <p>{profile.hobbies}</p>
          </div>
          <div>
            <h3>Description</h3>
            <p>{profile.description}</p>
          </div>
          <div>
            <h3>Availability</h3>
            <p>{profile.availability}</p>
          </div>
          <div>
            <h3>Marital Status</h3>
            <p>{profile.marital_status}</p>
          </div>
          <div>
            <h3>Tribe</h3>
            <p>{profile.tribe}</p>
          </div>
          <div>
            <h3>Languages</h3>
            <p>{profile.language}</p>
          </div>
          <div>
            <h3>Salary Expectation</h3>
            <p>${profile.salary}</p>
          </div>
          <div>
            <h3>City</h3>
            <p>{profile.city}</p>
          </div>
          <div>
            <h3>Address</h3>
            <p>{profile.address}</p>
          </div>
        </div>

        <div className={styles.additionalInfo}>
          <h2>Experience & Skills</h2>
          <p><b>Education:</b> {profile.education}</p>
          <p><b>Experience:</b> {profile.experience} years</p>
          <p><b>Skills:</b> {profile.skills}</p>
          <p><b>Certificates:</b> {profile.certificate || "None listed."}</p>
        </div>

        <AlbumsSection />
      </div>
    </div>
  );
};

export default HouseManagerProfile;
